export default __webpack_public_path__ + "static/media/kitemark-frame.f6453a40.svg";